import React from 'react'
import dayjs from 'dayjs'

import { Divider } from '@st-operations/uikit/src/v2/index.js'

import getMonthDifference from '_lib/getMonthDifference.js'
import { RANGE_TYPES } from '_services/insights-v2.js'
import MonthPicker from './MonthPicker.jsx'

import './TimeIntervalOptions.scss'

const YESTERDAY = dayjs().subtract(1, 'day').toISOString().split('T').at(0)
const ONE_YEAR_AGO = dayjs().subtract(1, 'year').toISOString().split('T').at(0)

const TimeIntervalOptions = ({
  timeRange,
  timeFrame,
  yLabels,
  timeIntervalOptions,
  onFieldChange,
  index,
}) => {
  const handleTimeRangeTypeChange = ({ currentTarget: { value } }) => {
    const newTimeRange = { ...timeRange, type: value }
    onFieldChange({ index, value: newTimeRange, type: 'time_range', field: 'time_range' })
  }

  const handleTimeRangeDateChange = (name, value) => {
    let newTimeRange = { ...timeRange }
    if (name === 'beginning' && getMonthDifference(new Date(value), new Date(timeRange.end)) <= 1) {
      const [year, month] = value.split('-')
      const newMonth = ('0' + (month + 1)).slice(-2)
      const isNextYear = newMonth > 12
      const newEndDate = isNextYear ? `${Number(year) + 1}-01-01` : `${year}-${newMonth}-01`
      newTimeRange.end = newEndDate
    } else {
      newTimeRange[name] = value
    }
    onFieldChange({ index, value: newTimeRange, type: 'time_range', field: 'time_range' })
  }

  const handleIntervalAndYAxis = ({ currentTarget: { name, value } }) =>
    onFieldChange({ index, value, type: name, field: name })

  const is_custom_range = timeRange?.type === RANGE_TYPES.CUSTOM

  return (
    <>
      <If condition={timeRange}>
        <p className="selected-entities-editor__title">Select your time interval:</p>
        <div className="selected-entities-editor__time-ranges">
          <label
            className={`selected-entities-editor__time-range ${!is_custom_range ? 'active' : ''}`}
          >
            12 Months
            <input
              name="time_range_type"
              value={RANGE_TYPES.PAST_12}
              checked={!is_custom_range}
              onChange={handleTimeRangeTypeChange}
              type="radio"
            />
          </label>
          <label
            className={`selected-entities-editor__time-range ${is_custom_range ? 'active' : ''}`}
          >
            Custom Range
            <input
              name="time_range_type"
              value={RANGE_TYPES.CUSTOM}
              checked={!!is_custom_range}
              onChange={handleTimeRangeTypeChange}
              type="radio"
            />
          </label>
        </div>
        <If condition={is_custom_range}>
          <div className="selected-entities-editor__time-range-inputs">
            <div className="selected-entities-editor__time-range-input">
              <p className="selected-entities-editor__time-range-label">From:</p>
              <MonthPicker
                from={ONE_YEAR_AGO}
                to={YESTERDAY}
                name="beginning"
                onChange={handleTimeRangeDateChange}
                value={timeRange.beginning}
              />
            </div>
            <div className="selected-entities-editor__time-range-input">
              <p className="selected-entities-editor__time-range-label">To:</p>
              <MonthPicker
                from={timeRange.beginning}
                to={YESTERDAY}
                name="end"
                onChange={handleTimeRangeDateChange}
                value={timeRange.end}
              />
            </div>
          </div>
        </If>
      </If>
      <If condition={timeFrame && timeIntervalOptions}>
        <p className="selected-entities-editor__text">Select how to display your interval:</p>
        <div className="selected-entities-editor__time-intervals">
          <For each="item" of={timeIntervalOptions}>
            <label
              key={item.text}
              className={`selected-entities-editor__radio ${
                item.value === timeFrame ? 'active' : ''
              }`}
            >
              <input
                className="selected-entities-editor__radio-input"
                type="radio"
                name="time_frame"
                onChange={handleIntervalAndYAxis}
                value={item.value}
                checked={item.value === timeFrame}
              />
              <div className="selected-entities-editor__radio-text">
                <span>{item.text}</span>
              </div>
            </label>
          </For>
        </div>
      </If>
      <If condition={yLabels}>
        <p className="selected-entities-editor__text">Select what to display on the y-axis:</p>
        <div className="selected-entities-editor__time-intervals">
          <For each="item" of={['Percent', 'Count']}>
            <label
              key={item}
              className={`selected-entities-editor__radio ${item === yLabels ? 'active' : ''}`}
            >
              <input
                className="selected-entities-editor__radio-input"
                type="radio"
                name="y_labels"
                onChange={handleIntervalAndYAxis}
                value={item}
                checked={item === yLabels}
              />
              <div className="selected-entities-editor__radio-text">
                <span>{item}</span>
              </div>
            </label>
          </For>
        </div>
      </If>
      <If condition={timeRange || (timeFrame && timeIntervalOptions) || yLabels}>
        <Divider className="selected-entities-editor__divider" />
      </If>
    </>
  )
}

export default TimeIntervalOptions
